import { InputDecimal } from "@/components/ui/input-decimal";
import { Switch } from "@/components/ui/switch";

export const BRL = (v) => Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
export const MODULOS = { Cardapio: "Cardápio", Delivery: "Delivery", Balcao: "Balcão", Mesas: "Mesas", MesaQR: "Mesa QR", Comandas: "Comandas", Totem: "Totem", ChatBot: "WhatsApp" };
export const SEGMENTOS = {
  vip: ["Cliente VIP", "mais de 4 pedidos em 30 dias"], recorrente: ["Recorrente", "3 ou 4 pedidos em 30 dias"],
  novo: ["Novo", "ainda não comprou"], primeiro_pedido: ["1º Pedido", "comprou 1 vez"],
  em_risco: ["Em Risco", "última compra entre 31 e 60 dias"], perdido: ["Perdido", "última compra há mais de 60 dias"],
  ativo: ["Ativo", "os demais clientes"],
};
export const TIPOS_PREMIO = {
  produto: "Produto grátis", pizza: "Pizza grátis (um tamanho)", desconto_valor: "Desconto em R$", desconto_pct: "Desconto em %", frete: "Frete grátis",
};

/** Bloco da página. Com `numero`, vira uma etapa numerada (1. Prêmio, 2. Quem ganha…). */
export function Secao({ titulo, descricao, children, acao, numero }) {
  return (
    <section className="rounded-2xl border bg-card p-4 sm:p-5">
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex items-start gap-3 min-w-0">
          {numero && <span className="w-7 h-7 rounded-full bg-primary text-primary-foreground text-sm font-bold grid place-items-center shrink-0">{numero}</span>}
          <div className="min-w-0">
            <h2 className="font-semibold">{titulo}</h2>
            {descricao && <p className="text-xs text-muted-foreground mt-0.5">{descricao}</p>}
          </div>
        </div>
        {acao}
      </div>
      {children}
    </section>
  );
}

export function Chave({ rotulo, ajuda, marcado, onChange, e2e }) {
  return (
    <label className="flex items-start justify-between gap-4 py-2.5 border-b last:border-0 cursor-pointer">
      <span className="text-sm">
        <span className="font-medium">{rotulo}</span>
        {ajuda && <span className="block text-xs text-muted-foreground mt-0.5">{ajuda}</span>}
      </span>
      <Switch checked={!!marcado} onCheckedChange={onChange} data-e2e={e2e} />
    </label>
  );
}

export function Numero({ valor, onChange, prefixo, sufixo, min = 0, max, passo = 1, largura = "w-24", e2e }) {
  return (
    <span className="inline-flex items-center rounded-lg border bg-background focus-within:ring-2 focus-within:ring-primary/30">
      {prefixo && <span className="pl-2.5 text-sm text-muted-foreground">{prefixo}</span>}
      <input type="number" inputMode="decimal" min={min} max={max} step={passo} value={valor ?? ""} data-e2e={e2e}
        onChange={(e) => onChange(e.target.value === "" ? "" : Number(e.target.value))}
        className={`${largura} h-9 px-2.5 bg-transparent text-sm outline-none`} />
      {sufixo && <span className="pr-2.5 text-sm text-muted-foreground">{sufixo}</span>}
    </span>
  );
}

export function Pilula({ ativo, onClick, children, e2e }) {
  return (
    <button type="button" onClick={onClick} data-e2e={e2e}
      className={`px-3 h-8 rounded-full border text-xs font-semibold transition-colors ${ativo
        ? "bg-primary text-primary-foreground border-primary" : "bg-background text-muted-foreground hover:border-primary/50"}`}>
      {children}
    </button>
  );
}

/** Valor em R$ "de caixa registradora": começa em R$ 0,00 e cada dígito entra
 *  pela direita (dono, 24/10/2026). `zeroVazio`: R$ 0,00 vira "" (campo opcional). */
export function Dinheiro({ valor, onChange, largura = "w-32", zeroVazio = false, e2e }) {
  const v = valor === "" || valor == null ? "0" : String(valor);
  return (
    <div className={`relative ${largura}`}>
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-muted-foreground pointer-events-none z-10">R$</span>
      <InputDecimal decimals={2} value={v} data-e2e={e2e} className="h-9 pl-9"
        onChange={(x) => { const n = x === "" ? 0 : Number(x); onChange(zeroVazio && !n ? "" : n); }} />
    </div>
  );
}
